export function loadImage (src, options) {
  return new Promise((resolve, reject) => {
    const loader = new Image();

    Object.assign(loader, options);

    loader.onload = function () {
      resolve(loader);
    };
    loader.onerror = function (err) {
      reject(new Error(err));
    };

    loader.crossOrigin = 'anonymous';
    loader.src = src;
  });
}
